import React from "react";
import { useTranslation } from "react-i18next";
import { useRillContext } from "../../rill/RillReact/share/base";

function View(props) {
  const { t } = useTranslation("auth");
  const { locals } = useRillContext();

  const {
    params: { token },
  } = locals;
  return (
    <div id="login-wrapper">
      <form method="POST" action="/actions/user/update-password" data-noreset>
        <img
          className="logo"
          src="/img/msb-logo-white.svg"
          alt={t("step2.logoAlt")}
        />
        <input type="hidden" name="token" value={token} />

        <div className="Steps" data-step="3">
          <div className="step"></div>
          <div className="step"></div>
          <div className="step"></div>
          <div className="step"></div>
        </div>

        <div className="frame">
          <div className="head">
            <h1 className="alt">{t("step2.title")}</h1>
          </div>

          <div className="columns">
            <div className="column" data-col="1/1">
              <label htmlFor="password" className="label">
                {t("step2.passwordLabel")}{" "}
                <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                required
                type="password"
                name="password"
                placeholder={t("step2.passwordPlaceholder")}
              />
            </div>

            <div className="column" data-col="1/1">
              <label htmlFor="confirmPassword" className="label">
                {t("step2.confirmPasswordLabel")}{" "}
                <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                required
                type="password"
                name="confirmPassword"
                placeholder={t("step2.confirmPasswordPlaceholder")}
              />
            </div>

            <div className="column" data-col="1/1">
              <button className="button-input full" type="submit">
                {t("step2.savePassword")}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

const Step2 = (app) => {
  app.get("/step2/:token", ({ res }) => (res.body = <View />));
};

export default Step2;
